/* eslint-disabled */

export default class ActionExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
